module.exports = __webpack_public_path__ + "images/emoji/u6e80.5ac982379c4c3ded2591.png";